<div class="input-container" [ngClass]="{'hidden': compressed}">
  <ng-container *ngTemplateOutlet="template"></ng-container>
  @if (!(showClear$ | async)) {
    <i class="material-icons global-search-icon">&#xE8B6;</i>
  }
  @if (showClear$ | async) {
    <i (click)="clear()" class="material-icons" style="cursor: pointer">clear</i>
  }
</div>

@if (compressed) {
  <ui-icon-button class="icon-button" (click)="showSearch()">
    <i class="material-icons global-search-icon">&#xE8B6;</i>
  </ui-icon-button>
}
